module.exports = __webpack_public_path__ + "static/img/safety-production-license1.b02fcf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/safety-production-license1.png
// module id = rVIT
// module chunks = 0